import { createElement } from 'react'
import type { RouteObject } from 'react-router-dom'
import type { createStore } from 'jotai'
import { AppContainer } from './AppContainer'
import { pageLinks } from './pageLinks'
import { RouteErrorBoundary } from './components/RouteErrorBoundary'
import NotFoundPage from './pages/NotFoundPage'
import Login from './pages/function/Login'
import Home from './pages/function/Home'
import Settings from './pages/function/Settings'
import ChangePassword from './pages/function/ChangePassword'
import UserManagement from './pages/function/UserManagement'
import CustomExercise from './pages/function/CustomExercise'
import WeeklyDetail from './pages/function/WeeklyDetail'
import MonthlyCalendar from './pages/function/MonthlyCalendar'
import ChangeLog from './pages/function/ChangeLog'

type Store = ReturnType<typeof createStore>

export function createRoutes(_store: Store): RouteObject[] {
  return [
    {
      path: '/',
      element: createElement(AppContainer),
      errorElement: createElement(RouteErrorBoundary),
      children: [
        { path: pageLinks.Login(), element: createElement(Login) },
        { path: pageLinks.Home(), element: createElement(Home) },
        { path: pageLinks.Settings(), element: createElement(Settings) },
        { path: pageLinks.ChangePassword(), element: createElement(ChangePassword) },
        { path: pageLinks.UserManagement(), element: createElement(UserManagement) },
        { path: '/exercise/custom/:exerciseKey', element: createElement(CustomExercise) },
        { path: pageLinks.WeeklyDetail(), element: createElement(WeeklyDetail) },
        { path: pageLinks.MonthlyCalendar(), element: createElement(MonthlyCalendar) },
        { path: pageLinks.ChangeLog(), element: createElement(ChangeLog) },
        { path: '*', element: createElement(NotFoundPage) },
      ],
    },
  ]
}
